const SEARCH = "/vehicles/controlwafers/searchvehicle"
const CREATE = "/vehicles/controlwafers/create"
const LIST = "/vehicles/controlwafers/list"
const DETAILS = "/vehicles/controlwafers/onevehicle"
const UPLOAD = "/vehicles/controlwafers/upload" 
const DELETE_FILE = "/vehicles/controlwafers/delete"
const FINALIZE = "/vehicles/controlwafers/finish"
const DELETE = "/vehicles/controlwafers"
const EXPORT = "/vehicles/controlwafers/export"
const EDIT = "/vehicles/controlwafers"
const DOWNLOAD = "/vehicles/controlwafers/informeingeniero/"

export const wafersWithControlEndpoints = {
    SEARCH,
    CREATE,
    LIST,
    DETAILS,
    UPLOAD,
    DELETE_FILE,
    FINALIZE,
    DELETE,
    EXPORT,
    EDIT,
    DOWNLOAD
}